export const FILTER_TYPES = {
  NETWORK: 'network',
  GROUP: 'group',
  MY_GROUPS: 'my_groups',
};
